import React from 'react';
import styled from 'styled-components';
import {
  elementColours,
  fontSize,
  fontWeights,
  minBreakpointQuery,
  sectionMargins,
} from '../styles';
import { Container, HtmlContent } from './ui';

const StyledFileDownloads = styled.div`
  ${sectionMargins('20px', '40px')};
`;

const StyledHeader = styled.header`
  margin-bottom: 16px;

  ${minBreakpointQuery.small`
    margin-bottom: 18px;
  `}
`;

const StyledHeading = styled.h4`
  font-weight: ${fontWeights.semibold};
  ${fontSize(19)};
  line-height: 1.5;

  ${minBreakpointQuery.small`
    ${fontSize(20)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(21)};
  `}
`;

const StyledText = styled(HtmlContent)`
  margin-top: 10px;

  ${minBreakpointQuery.small`
    margin-top: 12px;
  `}
`;

const StyledList = styled.ul`
  display: grid;
  gap: 12px;
`;

const StyledItem = styled.li`
  position: relative;
  padding-left: 20px;

  &:before {
    content: '';
    position: absolute;
    top: 8px;
    left: 0;
    display: inline-block;
    height: 8px;
    width: 8px;
    background-color: ${elementColours.textColour};
    border-radius: 50%;
  }
`;

const StyledLink = styled.a`
  text-decoration: underline;
`;

const FileDownloads = ({ heading, text, items }) => (
  <StyledFileDownloads>
    <Container narrow={true}>
      <StyledHeader>
        <StyledHeading>{heading}</StyledHeading>
        <StyledText content={text} />
      </StyledHeader>
      <StyledList>
        {items.map(({ title, url, format }, id) => (
          <StyledItem key={id}>
            <StyledLink href={url} download>
              {title} [{format.toUpperCase()}]
            </StyledLink>
          </StyledItem>
        ))}
      </StyledList>
    </Container>
  </StyledFileDownloads>
);

export default FileDownloads;
